"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");

var _unifiedHeaderFlyout = _interopRequireDefault(require("./unifiedHeaderFlyout"));

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _div;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OfficeRightNav = function OfficeRightNav(_ref) {
  var isAuth = _ref.isAuth,
      errorLoadingBusinessDetails = _ref.errorLoadingBusinessDetails,
      isLoadingBusinessDetails = _ref.isLoadingBusinessDetails,
      logout = _ref.logout,
      numberOfBusinesses = _ref.numberOfBusinesses,
      proCity = _ref.proCity,
      proRegion = _ref.proRegion,
      proName = _ref.proName,
      proType = _ref.proType,
      rating = _ref.rating,
      reviewCount = _ref.reviewCount,
      spId = _ref.spId,
      displaySpId = _ref.displaySpId,
      userId = _ref.userId,
      getAdsServiceProvider = _ref.getAdsServiceProvider,
      isAngiLeads = _ref.isAngiLeads,
      isAdvertiser = _ref.isAdvertiser,
      isNorthStar = _ref.isNorthStar,
      isAgreementOnlineEnroll = _ref.isAgreementOnlineEnroll;
  var calendarBannerCookieKey = 'spid_of_calendar_banner_closed';

  var signOut = function signOut() {
    (0, _cookieUtils.deleteCookie)(calendarBannerCookieKey);
    logout(userId);
  };

  var showFlyout = proName || proCity || proRegion || displaySpId;
  (0, _react.useEffect)(function () {
    if (isAuth && spId && !isAngiLeads && !showFlyout) {
      getAdsServiceProvider(spId);
    }
  }, [showFlyout, isAuth, isAngiLeads, spId]);
  var userLocation = "".concat(proCity || '').concat(proCity && proRegion ? ', ' : '').concat(proRegion || '');
  return /*#__PURE__*/_react["default"].createElement("div", null, isLoadingBusinessDetails || errorLoadingBusinessDetails ? _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null)) : isAuth && spId && showFlyout ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "office-right-nav"
  }, /*#__PURE__*/_react["default"].createElement(_unifiedHeaderFlyout["default"], {
    logout: logout,
    numberOfBusinesses: numberOfBusinesses,
    proLocation: userLocation,
    proName: proName,
    proType: proType,
    rating: rating,
    reviewCount: reviewCount,
    spId: spId,
    displaySpId: displaySpId,
    userId: userId,
    isAngiLeads: isAngiLeads,
    isAdvertiser: isAdvertiser,
    isNorthStar: isNorthStar,
    isAgreementOnlineEnroll: isAgreementOnlineEnroll
  })) : isAuth ? !spId ? /*#__PURE__*/_react["default"].createElement("small", {
    key: "unified-header-right-nav--sign-out"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-nav-item-sign-out",
    "data-track-activity-location": proType === 'Angi Ads' ? 'Ads Auth Header' : 'Leads Auth Header',
    "data-track-description": "Sign out",
    href: "/",
    id: "unified-header-right-nav--sign-out",
    onClick: signOut
  }, "Sign out"))) : null : !isAuth ? /*#__PURE__*/_react["default"].createElement("small", {
    key: "unified-header-right-nav--create-an-account"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-track-description": "Create an account or sign in",
    id: "unified-header-create-account-or-sign-in"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-sign-in",
    id: "unified-header-right-nav--sign-in",
    href: _urlCatalog["default"].office.login()
  }, "Sign in"), /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-nav-item",
    id: "unified-header-right-nav--create-an-account",
    href: _urlCatalog["default"].office.join()
  }, "Join us")))) : null);
};

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}))(OfficeRightNav);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/officeRightNav.js
// module id = 3580
// module chunks = 25